






























































import { Component, Mixins } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import corporateService from "@/services/corporate.service"
import commonService from "@/services/common.service"
import PageMixin from "@/mixins/page"
import { getColumns } from "./constant"
import { mapGetters } from "vuex"
import { omit } from "lodash"
import CorporateEdit from "./edit.vue"

@Component({
    components: {
        PageHeader,
        CorporateEdit
    },
    computed: {
        ...mapGetters(["currentUser"])
    }
})
export default class CorporateConfig extends Mixins(PageMixin) {
    readonly currentUser: any
    searchValue = ""
    loading = false
    dataSource: any = []
    visible = false
    lineData: any = {}
    fromType = "add"
    userRoles: { system_roles: any[] } = { system_roles: [] }
    isAdmin = false

    pagination = {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showLessItems: true,
        size: "normal",
        total: 0,
        pageSizeOptions: ["10", "20", "30", "40", "100"],
        showTotal: (total: number) => `共${total}项`
    }

    get vPaginationBinds() {
        const exclude = ["showTotal"]
        return omit(this.pagination, exclude)
    }

    get columns() {
        const cols: any = [
            {
                title: "启用状态",
                dataIndex: "status",
                width: 100,
                scopedSlots: { customRender: "status" }
            }
        ]
        return [...getColumns, ...cols]
    }

    get tableActions() {
        return () => {
            if (this.isAdmin) {
                return [{ title: "编辑", event: "edit" }]
            }
            return []
        }
    }

    created() {
        this.getList()
        this.getUserRoles()
    }

    async getUserRoles() {
        try {
            const res = await commonService.getUserRoles({
                user_id: this.currentUser.uid
            })
            this.userRoles = res || {}
            this.isAdmin = this.userRoles.system_roles.includes("admin")
        } catch (error) {
            this.$message.error(`获取权限失败！${error}`)
        }
    }

    handleAdd() {
        this.fromType = "add"
        this.lineData = {}
        this.visible = true
    }

    onEdit(records: any[]) {
        this.fromType = "edit"
        this.lineData = records[0]
        this.visible = true
    }

    onInputSearch() {
        this.pagination.current = 1
        this.getList()
    }

    handlePageChange(page: number, pageSize: number) {
        this.pagination.current = page
        this.pagination.pageSize = pageSize
        this.getList()
    }

    handleShowSizeChange(current: number, size: number) {
        this.pagination.pageSize = size
        this.pagination.current = 1
        this.getList()
    }

    onChangeSwitch(checked: any) {
        const text = checked.status == 1 ? "禁用" : "启用"
        this.$confirm({
            title: `${text}公司主体`,
            content: `您是否确认${text}该公司主体`,
            okText: "确认",
            cancelText: "取消",
            icon: (h: any) => {
                return h("a-icon", {
                    props: {
                        type: "exclamation-circle",
                        style: "background: yellow"
                    }
                })
            },
            async onOk() {
                checked.status = checked.status == 1 ? 2 : 1
                const payload = { id: checked.id, status: checked.status }
                await corporateService.corporateEnableOrDisable(payload)
            }
        })
    }

    async getList() {
        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize
        const payload: any = {
            offset,
            limit,
            keyword: this.searchValue
        }
        this.loading = true
        try {
            const res = await corporateService.getCorporateList(payload)
            const { total, list } = res
            this.dataSource = list || []
            this.pagination.total = total
        } catch (error) {
            if (error) {
                this.$message.error(`获取数据失败！ ${error}`)
            }
        } finally {
            this.loading = false
        }
    }
}
